const trainingUsers = {
  defaultSortValue: {
    sortname: 'name',
    order: 'desc',
  },
  selecting: false,
  sort: ['name', 'view'],
  rowClick: false,
  head: [
    {
      id: 'name',
      label: 'Name',
      align: 'left',
    },
    {
      id: 'view',
      label: 'View',
      align: 'left',
    },
  ],
};

export default trainingUsers;
